import {
    GetPlusFetchFailureAction,
    GetPlusFetchRequestAction,
    GetPlusFetchSuccessAction,
    GET_PLUS_FETCH_FAILURE,
    GET_PLUS_FETCH_REQUEST,
    GET_PLUS_FETCH_SUCCESS,
} from 'mk2/apps/plan/containers/GetPlus/GetPlus.actions';
import { PriceListItem } from 'mk2/apps/plan/schemas';
import { tupdate } from 'mk2/helpers/types';
import { errorMessage } from 'mk2/reducers/errorMessage';
import { loadingState, LoadingState } from 'mk2/reducers/loadingState';
import { Reducer } from 'redux';

export interface GetPlusState {
    allowPayments: boolean;
    avatars: number[];
    bazaarPlusId: number;
    errorMessage: string;
    loadingState: LoadingState;
    paymentVS: string;
    planIsActiveAndDisplaying: boolean;
    plusPrices: PriceListItem[];
}

export const initialGetPlusState: GetPlusState = {
    allowPayments: true,
    avatars: [],
    bazaarPlusId: null,
    errorMessage: null,
    loadingState: LoadingState.INIT,
    paymentVS: null,
    planIsActiveAndDisplaying: null,
    plusPrices: null,
};

declare type GetPlusReducerAction =
    GetPlusFetchRequestAction
    | GetPlusFetchSuccessAction
    | GetPlusFetchFailureAction;

const getPlusReducer: Reducer<GetPlusState> = (state = initialGetPlusState, action: GetPlusReducerAction) => {
    switch (action.type) {
        case GET_PLUS_FETCH_REQUEST:
        case GET_PLUS_FETCH_FAILURE: {
            return tupdate(state, {
                loadingState: loadingState(undefined, action),
                errorMessage: errorMessage(undefined, action),
            });
        }

        case GET_PLUS_FETCH_SUCCESS: {
            return tupdate(state, {
                allowPayments: action.response.result.allowPayments,
                avatars: action.response.result.avatars,
                bazaarPlusId: action.response.result.bazaarPlusId,
                errorMessage: errorMessage(undefined, action),
                loadingState: loadingState(undefined, action),
                paymentVS: action.response.result.paymentVS,
                planIsActiveAndDisplaying: action.response.result.planIsActiveAndDisplaying,
                plusPrices: action.response.result.plusPrices,
            });
        }

        default:
            return state;
    }
};

export default getPlusReducer;
